(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ThumbnailSlider"] = factory();
	else
		root["ThumbnailSlider"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.l = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };

/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};

/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};

/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* styles */
__webpack_require__(4)

/* script */
__vue_exports__ = __webpack_require__(6)

/* template */
var __vue_template__ = __webpack_require__(2)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
if (Object.keys(__vue_exports__).some(function (key) { return key !== "default" && key !== "__esModule" })) {console.error("named exports are not supported in *.vue files.")}
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}
__vue_options__.__file = "/Users/huangdong/Documents/workspace/thumbnail-slider/src/tn-item.vue"
__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6f32c575", __vue_options__)
  } else {
    hotAPI.reload("data-v-6f32c575", __vue_options__)
  }
})()}
if (__vue_options__.functional) {console.error("[vue-loader] tn-item.vue: functional components are not supported and should be defined in plain js files using render functions.")}

module.exports = __vue_exports__


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__
var __vue_styles__ = {}

/* styles */
__webpack_require__(5)

/* script */
__vue_exports__ = __webpack_require__(7)

/* template */
var __vue_template__ = __webpack_require__(3)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
if (Object.keys(__vue_exports__).some(function (key) { return key !== "default" && key !== "__esModule" })) {console.error("named exports are not supported in *.vue files.")}
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}
__vue_options__.__file = "/Users/huangdong/Documents/workspace/thumbnail-slider/src/tn-slider.vue"
__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-774101c3", __vue_options__)
  } else {
    hotAPI.reload("data-v-774101c3", __vue_options__)
  }
})()}
if (__vue_options__.functional) {console.error("[vue-loader] tn-slider.vue: functional components are not supported and should be defined in plain js files using render functions.")}

module.exports = __vue_exports__


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tn-item",
    on: {
      "click": function($event) {
        _vm.clickHandler()
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6f32c575", module.exports)
  }
}

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tn-slider",
    class: {
      'tn-slider-row': _vm.direction == 'row'
    }
  }, [_c('div', {
    staticClass: "tn-prev",
    on: {
      "click": function($event) {
        _vm.slidePrev()
      }
    }
  }, [_vm._t("tn-prev")], 2), _vm._v(" "), _c('div', {
    staticClass: "tn-transform-container"
  }, [_c('div', {
    staticClass: "tn-transform-wrapper"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tn-next",
    on: {
      "click": function($event) {
        _vm.slideNext()
      }
    }
  }, [_vm._t("tn-next")], 2)])
},staticRenderFns: []}
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-774101c3", module.exports)
  }
}

/***/ },
/* 4 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 5 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 6 */
/***/ function(module, exports) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	name: 'tn-item',

	props: {},

	data: function data() {
		return {};
	},


	methods: {
		clickHandler: function clickHandler() {
			this.$emit('on-item-click', { vm: this });
		}
	}

};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

__webpack_require__(8);

exports.default = {
	name: 'tn-slider',

	props: {
		count: {
			type: Number,
			default: 1
		},
		index: {
			type: Number,
			default: 0
		},
		direction: {
			type: String,
			default: 'row'
		},
		animation: {
			type: String,
			default: 'ease'
		},
		hideNav: {
			type: Boolean,
			default: false
		}
	},

	data: function data() {
		return {
			$transformWrapper: null,
			fullLength: 0,
			currentEl: null,
			allImgs: [],
			directionAtrMap: {
				translate: {
					row: 'translateX',
					column: 'translateY'
				},
				offset: {
					row: 'offsetLeft',
					column: 'offsetTop'
				},
				size: {
					row: 'clientWidth',
					column: 'clientHeight'
				},
				scrollSize: {
					row: 'scrollWidth',
					column: 'scrollHeight'
				}
			},
			ANIMATION_TIME: 400
		};
	},


	watch: {
		index: function index() {
			var $el = this.$el.getElementsByClassName("tn-item")[this.index];
			if ($el) {
				this._slideToItem($el);
			}
		},
		fullLength: function fullLength() {
			this.resize();
		}
	},

	mounted: function mounted() {
		var _this = this;

		var wrapper = this.$el.getElementsByClassName('tn-transform-wrapper')[0];
		Transform(wrapper);
		this.$transformWrapper = wrapper;
		setTimeout(function () {
			_this.fullLength = _this.$el.getElementsByClassName('tn-transform-container')[0][_this.directionAtrMap.size[_this.direction]];
		}, 50);
		this._addResizeHandler();
	},


	methods: {
		slidePrev: function slidePrev() {
			this._slideBy(this.$transformWrapper[this.directionAtrMap.translate[this.direction]] + this.fullLength);
		},
		slideNext: function slideNext() {
			this._slideBy(this.$transformWrapper[this.directionAtrMap.translate[this.direction]] - this.fullLength);
		},
		resetSliderPos: function resetSliderPos() {
			this.$transformWrapper[this.directionAtrMap.translate[this.direction]] = 0;
		},
		resize: function resize() {
			var _this2 = this;

			this.fullLength = this.$el.getElementsByClassName('tn-transform-container')[0][this.directionAtrMap.size[this.direction]];
			var els = this.$el.getElementsByClassName('tn-item');
			var elLength = this.fullLength / this.count;
			Array.prototype.map.call(els, function (el) {
				_this2.direction == 'column' ? el.style.height = elLength + 'px' : el.style.width = elLength + 'px';
			});
			this._slideToItem(els[this.index], true);
		},
		_slideToItem: function _slideToItem(item, noAnimating) {
			var offset = .5 * this.fullLength - .5 * this.fullLength / this.count - item[this.directionAtrMap.offset[this.direction]];
			this._slideBy(offset, noAnimating);
		},
		_slideBy: function _slideBy(offset, noAnimating) {
			var size = this.$el.getElementsByClassName('tn-transform-wrapper')[0][this.directionAtrMap.scrollSize[this.direction]];
			var translateAtr = this.directionAtrMap.translate[this.direction];
			if (offset >= 0 || this.fullLength > size) {
				offset = 0;
			}
			if (offset < 0 && offset <= this.fullLength - size) {
				offset = this.fullLength - size;
			}
			if (this.animation == 'ease' && !noAnimating) {
				this._animate(this.$transformWrapper, translateAtr, offset, this.ANIMATION_TIME, this._ease, null);
			} else {
				this.$transformWrapper[translateAtr] = offset;
			}
		},
		_addResizeHandler: function _addResizeHandler() {
			var resizeTimeout = void 0;
			var self = this;
			function resizeThrottler() {
				if (!resizeTimeout) {
					resizeTimeout = setTimeout(function () {
						resizeTimeout = null;
						self.resize();
					}, 16);
				}
			}
			window.addEventListener("resize", self.resize, false);
		},
		_animate: function _animate(el, property, value, time, ease, onEnd, onChange) {
			var current = el[property];
			var dv = value - current;
			var beginTime = new Date();
			var self = this;
			var currentEase = ease || function (a) {
				return a;
			};
			this.tickID = null;
			var toTick = function toTick() {
				var dt = new Date() - beginTime;
				if (dt >= time) {
					el[property] = value;
					onChange && onChange(value);
					onEnd && onEnd(value);
					cancelAnimationFrame(self.tickID);
					self.toTick = null;
					return;
				}
				el[property] = dv * currentEase(dt / time) + current;
				self.tickID = requestAnimationFrame(toTick);
				onChange && onChange(el[property]);
			};
			toTick();
		},
		_ease: function _ease(x) {
			return Math.sqrt(1 - Math.pow(x - 1, 2));
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ },
/* 8 */
/***/ function(module, exports) {

"use strict";
"use strict";

/* transformjs
 * By dntzhang
 * Github: https://github.com/AlloyTeam/AlloyTouch/tree/master/transformjs
 */
;(function () {

    var Matrix3D = function Matrix3D(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        this.elements = window.Float32Array ? new Float32Array(16) : [];
        var te = this.elements;
        te[0] = n11 !== undefined ? n11 : 1;te[4] = n12 || 0;te[8] = n13 || 0;te[12] = n14 || 0;
        te[1] = n21 || 0;te[5] = n22 !== undefined ? n22 : 1;te[9] = n23 || 0;te[13] = n24 || 0;
        te[2] = n31 || 0;te[6] = n32 || 0;te[10] = n33 !== undefined ? n33 : 1;te[14] = n34 || 0;
        te[3] = n41 || 0;te[7] = n42 || 0;te[11] = n43 || 0;te[15] = n44 !== undefined ? n44 : 1;
    };

    Matrix3D.DEG_TO_RAD = Math.PI / 180;

    Matrix3D.prototype = {
        set: function set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
            var te = this.elements;
            te[0] = n11;te[4] = n12;te[8] = n13;te[12] = n14;
            te[1] = n21;te[5] = n22;te[9] = n23;te[13] = n24;
            te[2] = n31;te[6] = n32;te[10] = n33;te[14] = n34;
            te[3] = n41;te[7] = n42;te[11] = n43;te[15] = n44;
            return this;
        },
        identity: function identity() {
            this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            return this;
        },
        multiplyMatrices: function multiplyMatrices(a, be) {

            var ae = a.elements;
            var te = this.elements;
            var a11 = ae[0],
                a12 = ae[4],
                a13 = ae[8],
                a14 = ae[12];
            var a21 = ae[1],
                a22 = ae[5],
                a23 = ae[9],
                a24 = ae[13];
            var a31 = ae[2],
                a32 = ae[6],
                a33 = ae[10],
                a34 = ae[14];
            var a41 = ae[3],
                a42 = ae[7],
                a43 = ae[11],
                a44 = ae[15];

            var b11 = be[0],
                b12 = be[1],
                b13 = be[2],
                b14 = be[3];
            var b21 = be[4],
                b22 = be[5],
                b23 = be[6],
                b24 = be[7];
            var b31 = be[8],
                b32 = be[9],
                b33 = be[10],
                b34 = be[11];
            var b41 = be[12],
                b42 = be[13],
                b43 = be[14],
                b44 = be[15];

            te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
            te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
            te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
            te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;

            te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
            te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
            te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
            te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;

            te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
            te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
            te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
            te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;

            te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
            te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
            te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
            te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;

            return this;
        },
        // 解决角度为90的整数倍导致Math.cos得到极小的数，其实是0。导致不渲染
        _rounded: function _rounded(value, i) {
            i = Math.pow(10, i || 15);
            // default
            return Math.round(value * i) / i;
        },
        appendTransform: function appendTransform(x, y, z, scaleX, scaleY, scaleZ, rotateX, rotateY, rotateZ, skewX, skewY, originX, originY, originZ) {

            var rx = rotateX * Matrix3D.DEG_TO_RAD;
            var cosx = this._rounded(Math.cos(rx));
            var sinx = this._rounded(Math.sin(rx));
            var ry = rotateY * Matrix3D.DEG_TO_RAD;
            var cosy = this._rounded(Math.cos(ry));
            var siny = this._rounded(Math.sin(ry));
            var rz = rotateZ * Matrix3D.DEG_TO_RAD;
            var cosz = this._rounded(Math.cos(rz * -1));
            var sinz = this._rounded(Math.sin(rz * -1));

            this.multiplyMatrices(this, [1, 0, 0, x, 0, cosx, sinx, y, 0, -sinx, cosx, z, 0, 0, 0, 1]);

            this.multiplyMatrices(this, [cosy, 0, siny, 0, 0, 1, 0, 0, -siny, 0, cosy, 0, 0, 0, 0, 1]);

            this.multiplyMatrices(this, [cosz * scaleX, sinz * scaleY, 0, 0, -sinz * scaleX, cosz * scaleY, 0, 0, 0, 0, 1 * scaleZ, 0, 0, 0, 0, 1]);

            if (skewX || skewY) {
                this.multiplyMatrices(this, [this._rounded(Math.cos(skewX * Matrix3D.DEG_TO_RAD)), this._rounded(Math.sin(skewX * Matrix3D.DEG_TO_RAD)), 0, 0, -1 * this._rounded(Math.sin(skewY * Matrix3D.DEG_TO_RAD)), this._rounded(Math.cos(skewY * Matrix3D.DEG_TO_RAD)), 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
            }

            if (originX || originY || originZ) {
                this.elements[12] -= originX * this.elements[0] + originY * this.elements[4] + originZ * this.elements[8];
                this.elements[13] -= originX * this.elements[1] + originY * this.elements[5] + originZ * this.elements[9];
                this.elements[14] -= originX * this.elements[2] + originY * this.elements[6] + originZ * this.elements[10];
            }
            return this;
        }
    };

    function observe(target, props, callback) {
        for (var i = 0, len = props.length; i < len; i++) {
            var prop = props[i];
            watch(target, prop, callback);
        }
    }

    function watch(target, prop, callback) {
        Object.defineProperty(target, prop, {
            get: function get() {
                return this["__" + prop];
            },
            set: function set(value) {
                if (value !== this["__" + prop]) {
                    this["__" + prop] = value;
                    callback();
                }
            }
        });
    }

    window.Transform = function (element, notPerspective) {

        observe(element, ["translateX", "translateY", "translateZ", "scaleX", "scaleY", "scaleZ", "rotateX", "rotateY", "rotateZ", "skewX", "skewY", "originX", "originY", "originZ"], function () {
            var mtx = element.matrix3D.identity().appendTransform(element.translateX, element.translateY, element.translateZ, element.scaleX, element.scaleY, element.scaleZ, element.rotateX, element.rotateY, element.rotateZ, element.skewX, element.skewY, element.originX, element.originY, element.originZ);
            element.style.transform = element.style.msTransform = element.style.OTransform = element.style.MozTransform = element.style.webkitTransform = (notPerspective ? "" : "perspective(" + (element.perspective === undefined ? 500 : element.perspective) + "px) ") + "matrix3d(" + Array.prototype.slice.call(mtx.elements).join(",") + ")";
        });

        element.matrix3D = new Matrix3D();

        if (!notPerspective) {
            observe(element, ["perspective"], function () {
                element.style.transform = element.style.msTransform = element.style.OTransform = element.style.MozTransform = element.style.webkitTransform = "perspective(" + element.perspective + "px) matrix3d(" + Array.prototype.slice.call(element.matrix3D.elements).join(",") + ")";
            });
            element.perspective = 500;
        }

        element.scaleX = element.scaleY = element.scaleZ = 1;
        //由于image自带了x\y\z，所有加上translate前缀
        element.translateX = element.translateY = element.translateZ = element.rotateX = element.rotateY = element.rotateZ = element.skewX = element.skewY = element.originX = element.originY = element.originZ = 0;
    };
})();

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TnSlider = exports.TnItem = undefined;

var _tnSlider = __webpack_require__(1);

var _tnSlider2 = _interopRequireDefault(_tnSlider);

var _tnItem = __webpack_require__(0);

var _tnItem2 = _interopRequireDefault(_tnItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.TnItem = _tnItem2.default;
exports.TnSlider = _tnSlider2.default;

/***/ }
/******/ ]);
});
//# sourceMappingURL=thumbnailSlider.min.js.map